import React, { useEffect, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import IframePageTemplate from 'Components/IframePageTemplate/IframePageTemplate'
import {
  getTrackingRestrictedCompanyIds,
  ROUTES,
  trackingIframeUrlsByCompany,
} from 'Utils/constants'
import { useSelector } from 'react-redux'

// IDs de compañías que tienen restricción de tracking
const TRACKING_RESTRICTED_COMPANY_IDS = getTrackingRestrictedCompanyIds()

export default function DashboardTracking() {
  const history = useHistory()
  const { CompanyId, WarehouseCode } = useSelector(state => state.company)

  // Verificar si la compañía actual tiene acceso al tracking
  const hasTrackingAccess = useMemo(
    () => !TRACKING_RESTRICTED_COMPANY_IDS.includes(CompanyId),
    [CompanyId]
  )

  const baseUrlTracking = trackingIframeUrlsByCompany[CompanyId]

  const dashboardUrlTracking = useMemo(() => {
    if (!baseUrlTracking) return ''

    const url = new URL(`${baseUrlTracking}/dashboard`)

    if (WarehouseCode) {
      url.searchParams.set('store', WarehouseCode)
    }

    return url.toString()
  }, [baseUrlTracking, WarehouseCode])

  useEffect(() => {
    if (!baseUrlTracking || !hasTrackingAccess) {
      history.replace(ROUTES.home)
    }
  }, [history, hasTrackingAccess, baseUrlTracking])

  return (
    <div data-testid="container-dashboard-tracking">
      <IframePageTemplate loading={false} iframeUrl={dashboardUrlTracking} />
    </div>
  )
}
